import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Wave = () => {
  const targetSection = document.querySelector('.purutsuya');
  const targetEl = document.querySelector('.purutsuya__ttl--waveContainer');

  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: targetSection,
    start: 'top-=5%',
    onEnter: () => {
      targetEl.classList.add('waveOn');
    },
  });
};

export default Wave;
